import React from 'react';
import styles from './Telecom.module.css';
// import backgroundImage from '../../Images/bg1.png';
import backgroundImage from '../../Images/bg26.png';
import T16 from '../../Images/T16.png'; // Import from images folder
import iconT21 from '../../Images/icon52.png'; 
import iconT22 from '../../Images/icon53.png';
import iconT23 from '../../Images/icon43.png';
import iconT24 from '../../Images/iconT24.png';
import iconT25 from '../../Images/iconT25.png';
import iconT26 from '../../Images/iconT26.png';
import iconT30 from '../../Images/iconT30.png';

import iconT44 from '../../Images/icon72.png'; 
import iconT45 from '../../Images/icon73.png'; 
import iconT46 from '../../Images/icon74.png'; 
import iconT47 from '../../Images/icon75.png'; 
import iconT48 from '../../Images/icon76.png'; 
import iconT49 from '../../Images/icon77.png'; 
import T41 from '../../Images/T41.png';
import T42 from '../../Images/T42.png';
import T43 from '../../Images/T43.png';
import T44 from '../../Images/T44.png';
import T52 from '../../Images/T52.png';
import T53 from '../../Images/T53.png';
import T54 from '../../Images/T54.png';
import T55 from '../../Images/T55.png';
import T62 from '../../Images/T62.png';
import icon12 from '../../Images/icon12.png';
import icon15 from '../../Images/icon15.png';
import icon16 from '../../Images/icon16.png';
import icon1 from '../../Images/icon41.png';
import icon2 from '../../Images/icon42.png';
import icon3 from '../../Images/icon43.png';
import icon4 from '../../Images/icon44.png';

import iconT54 from '../../Images/icon72.png';
import iconT56 from '../../Images/icon53.png';
import iconT57 from '../../Images/iconT57.png';
import bT1 from '../../Images/bT45.png';
import bT2 from '../../Images/bT2.png';
import bT3 from '../../Images/bT3.png';

// import bg1 from '../../Images/bg1.png';
// import cd1 from '../../Images/cd1.png';
// import cd2 from '../../Images/cd2.png';
// import cd3 from '../../Images/cd3.png';
// import cd4 from '../../Images/cd4.png';
// import sicon1 from '../../Images/sicon1.png';


const Telecom = () => {
  const handleCTAClick = (action) => {
    console.log(`${action} clicked`);
    // Add your navigation/modal logic here 
  };

  return (
     <div className={styles.container}>
    {/* Hero Section */}
    <section className={styles.heroSection}>
      <div className={styles.heroContent}>
        {/* Top label */}
        <div className={styles.heroLabel}>
          <span className={styles.labelText}>Telecom Industry Solutions</span>
        </div>
        
        {/* Main headline */}
        <h1 className={styles.heroHeadline}>
          Elevate Telecom Customer Experience with AI Intelligence
        </h1>
        
        {/* Subtext */}
        <p className={styles.heroSubtext}>
          Transform your customer support operations with intelligent AI agents 
          that understand, engage, and resolve telecom queries instantly—reducing 
          operational costs while boosting customer loyalty.
        </p>
        
        {/* CTA Buttons */}
        <div className={styles.ctaButtons}>
          <button 
            className={`${styles.ctaButton} ${styles.ctaPrimary}`}
            onClick={() => handleCTAClick('Request a Demo')}
          >
            Request a Demo →
          </button>
          <button 
            className={`${styles.ctaButton} ${styles.ctaSecondary}`}
            onClick={() => handleCTAClick('Learn More')}
          >
            Learn More
          </button>
        </div>
        
       
      </div>
      
      {/* Background Image Container */}
      <div className={styles.heroBackground}>
        <div 
          className={styles.backgroundImage}
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        />
      </div>
    </section>


      {/* Why AI-Powered Software Support
      <section className={styles.section}>
        <div className={styles.sectionContent}>
          <h2 className={styles.sectionTitle}>Why AI-Powered Software Support?</h2>
          <div className={styles.featuresGrid}>
            <div className={styles.featureCard}>
              <h3>24/7 Availability</h3>
              <p>Immediate assistance anytime for software issues.</p>
            </div>
            <div className={styles.featureCard}>
              <h3>Automated Fixes</h3>
              <p>AI detects errors and applies solutions instantly.</p>
            </div>
            <div className={styles.featureCard}>
              <h3>Reduce Downtime</h3>
              <p>Keep your software running smoothly.</p>
            </div>
            <div className={styles.featureCard}>
              <h3>Seamless Integration</h3>
              <p>Works with desktop, web, and mobile applications.</p>
            </div>
          </div>
        </div>
      </section> */}



      {/* section2*/}
<section className={styles.icon54}>
  <div className={styles.statsContainer}>
    <div className={styles.statItem}>
      <div className={styles.iconWrapper}>
        {/* Replace with your actual icon component or image */}
        <img src={icon1} alt="Users" className={styles.icon} />
      </div>
      <div className={styles.statNumber}>3.2M+</div>
      <div className={styles.statLabel}>Quartz Renewal Mobility</div>
    </div>
    
    <div className={styles.statItem}>
      <div className={styles.iconWrapper}>
        <img src={icon2} alt="Satisfaction" className={styles.icon} />
      </div>
      <div className={styles.statNumber}>89%</div>
      <div className={styles.statLabel}>Customer Satisfaction</div>
    </div>
    
    <div className={styles.statItem}>
      <div className={styles.iconWrapper}>
        <img src={icon3} alt="Support" className={styles.icon} />
      </div>
      <div className={styles.statNumber}>24/7</div>
      <div className={styles.statLabel}>Gentman's Support</div>
    </div>
    
    <div className={styles.statItem}>
      <div className={styles.iconWrapper}>
        <img src={icon4} alt="Speed" className={styles.icon} />
      </div>
      <div className={styles.statNumber}>60%</div>
      <div className={styles.statLabel}>Faster Remedium</div>
    </div>
  </div>
</section>


      {/* Key Features */}
      {/* <section className={styles.section}>
        <div className={styles.sectionContent}>
          <h2 className={styles.sectionTitle}>Key Features</h2>
          <div className={styles.featuresList}>
            <div className={styles.featureItem}>
              <h4>Automated Troubleshooting</h4>
              <p>AI identifies bugs, crashes, and compatibility issues.</p>
            </div>
            <div className={styles.featureItem}>
              <h4>Patch & Update Management</h4>
              <p>Keep all applications updated automatically.</p>
            </div>
            <div className={styles.featureItem}>   
              <h4>Multi-Channel Support</h4>
              <p>Access via chat, email, or web portal.</p>
            </div>
            <div className={styles.featureItem}>
              <h4>Knowledge Base Integration</h4>
              <p>Instant guidance from software manuals and documentation.</p>
            </div>
            <div className={styles.featureItem}>
              <h4>Analytics & Insights</h4>
              <p>Monitor software performance and recurring issues.</p>
            </div>
          </div>
        </div>
      </section> */}


      {/* The Telecom Support Challenge */}

        <section className={styles.section21}>
  <div className={styles.container21}>
    {/* Header Section */}
    <div className={styles.headerSection21}>
      <h1 className={styles.title21}>
        The Telecom Support Challenge 
        {/* <span className={styles.highlight21}>Retail</span> */}
      </h1>
      <p className={styles.subtitle21}>
        Telecom providers face mounting pressure to deliver instant support across multiple channels while managing costs and reducing customer frustration.
      </p>
    </div>

    {/* Capabilities Grid */}
    <div className={styles.capabilitiesGrid21}>
      {/* Card 1 */}
      <div className={styles.capabilityCard21}>
        <div className={styles.cardHeader21}>
          <div className={styles.cardIcon21}>
            <img 
              src={iconT21}
              alt="Customer Service Icon" 
              className={styles.iconImage21}
            />
          </div>
          <h3 className={styles.cardTitle21}>Overwhelmed Support</h3>
        </div>
        <p className={styles.cardDescription21}>
          Customer service agents spend countless hours on repetitive questions about billing, data usage, and basic troubleshooting—leading to burnout and high turnover.
        </p>
      </div>

      {/* Card 2 */}
      <div className={styles.capabilityCard21}>
        <div className={styles.cardHeader21}>
          <div className={styles.cardIcon21}>
            <img 
              src={iconT22} 
              alt="Customer Service Icon" 
              className={styles.iconImage21}
            />
          </div>
          <h3 className={styles.cardTitle21}>Peak Hour Bottlenecks</h3>
        </div>
        <p className={styles.cardDescription21}>
          Network outages and service disruptions create massive call spikes that traditional support systems simply can't handle, frustrating customers during critical moments.
        </p>
      </div>

      {/* Card 3 */}
      <div className={styles.capabilityCard21}>
        <div className={styles.cardHeader21}>
          <div className={styles.cardIcon21}>
            <img 
              src={iconT23} 
              alt="Customer Service Icon" 
              className={styles.iconImage21}
            />
          </div>
          <h3 className={styles.cardTitle21}>Rising Customer</h3>
        </div>
        <p className={styles.cardDescription21}>
          Modern customers expect immediate responses on their preferred channels—chat, voice, email, or social media—at any time of day or night.
        </p>
      </div>

      
    </div>
  </div>
</section>








        {/* How ToxboxAI Transforms Telecom Support */}

      <section className={styles.section44}>
  <div className={styles.container44}>
    {/* Header Section */}
    <div className={styles.headerSection44}>
      <h1 className={styles.title44}>
        How ToxboxAI Transforms Telecom Support 
        {/* <span className={styles.highlight44}>Retail</span> */}
      </h1>
      <p className={styles.subtitle44}>
        Our AI-powered platform seamlessly integrates with your existing systems to deliver intelligent, automated support that scales with your needs.
      </p>
    </div>

    {/* Capabilities Grid */}
    <div className={styles.capabilitiesGrid44}>
      {/* Card 1 */}
      <div className={styles.capabilityCard44}>
        <div className={styles.cardHeader44}>
          <div className={styles.cardIcon44}>
            <img 
              src={iconT44}
              alt="Customer Service Icon" 
              className={styles.iconImage44}
            />
          </div>
          <h3 className={styles.cardTitle44}>Network Diagnostics</h3>
        </div>
        <p className={styles.cardDescription44}>
          AI agents instantly diagnose connectivity issues, guide customers through troubleshooting steps, and escalate complex problems to specialists with full context.
        </p>
      </div>

      {/* Card 2 */}
      <div className={styles.capabilityCard44}>
        <div className={styles.cardHeader44}>
          <div className={styles.cardIcon45}>
            <img 
              src={iconT45} 
              alt="Customer Service Icon" 
              className={styles.iconImage44}
            />
          </div>
          <h3 className={styles.cardTitle44}>Billing Intelligence</h3>
        </div>
        <p className={styles.cardDescription44}>
          Automatically handle billing inquiries, process payments, explain charges, and offer personalized plan recommendations based on usage patterns.
        </p>
      </div>

      {/* Card 3 */}
      <div className={styles.capabilityCard44}>
        <div className={styles.cardHeader44}>
          <div className={styles.cardIcon46}>
            <img 
              src={iconT46} 
              alt="Customer Service Icon" 
              className={styles.iconImage44}
            />
          </div>
          <h3 className={styles.cardTitle44}>Service Configuration</h3>
        </div>
        <p className={styles.cardDescription44}>
          Enable customers to upgrade plans, add features, manage devices, and configure settings through natural conversation without agent intervention.
        </p>
      </div>

      {/* Card 4 */}
      <div className={styles.capabilityCard44}>
        <div className={styles.cardHeader44}>
          <div className={styles.cardIcon47}>
            <img 
              src={iconT47} 
              alt="Customer Service Icon" 
              className={styles.iconImage44}
            />
          </div>
          <h3 className={styles.cardTitle44}>Omnichannel Engagement</h3>
        </div>
        <p className={styles.cardDescription44}>
          Provide consistent support experiences across chat, voice, SMS, and social media—maintaining context as customers switch between channels.
        </p>
      </div>

      {/* Card 5 */}
      <div className={styles.capabilityCard44}>
        <div className={styles.cardHeader44}>
          <div className={styles.cardIcon48}>
            <img 
              src={iconT48} 
              alt="Customer Service Icon" 
              className={styles.iconImage44}
            />
          </div>
          <h3 className={styles.cardTitle44}>Proactive Outreach</h3>
        </div>
        <p className={styles.cardDescription44}>
          Anticipate customer needs with AI-driven insights, sending timely alerts about data limits, payment reminders, and personalized offers before issues arise.
        </p>
      </div>

      {/* Card 6 */}
      <div className={styles.capabilityCard44}>
        <div className={styles.cardHeader44}>
          <div className={styles.cardIcon49}>
            <img 
              src={iconT49} 
              alt="Customer Service Icon" 
              className={styles.iconImage44}
            />
          </div>
          <h3 className={styles.cardTitle44}>Multi-language Support</h3>
        </div>
        <p className={styles.cardDescription44}>
          Serve diverse customer bases with AI agents that communicate fluently in multiple languages, understanding context and cultural nuances.
        </p>
      </div>
    </div>
  </div>
</section>





      {/* Measurable Impact on Your Bottom Line*/}
<section className={styles.Intent45}>
  <div className={styles.container45}>
    <div className={styles.contentLeft45}>
      <h2 className={styles.heading45}>Measurable Impact on Your Bottom Line</h2>
      <p className={styles.description45}>
        ToxboxAI delivers quantifiable results from day one, helping telecom providers reduce costs while improving customer satisfaction and retention metrics.
      </p>
      <button className={styles.roiButton45}>
        Calculate Your ROI →
      </button>
    </div>
    
    <div className={styles.contentRight45}>
      <img 
        src={bT1} 
        alt="ToxboxAI performance metrics dashboard showing statistics"
        className={styles.dashboardImage45}
      />
    </div>
  </div>
</section>


      {/* Built for Every Telecom Segment*/}
      <section className={styles.section26}>
  <div className={styles.container26}>
    {/* Header Section */}
    <div className={styles.headerSection26}>
      <h1 className={styles.title26}>
        Built for Every Telecom Segment
      </h1>
      <p className={styles.subtitle26}>
        Whether you're serving consumers, businesses, or enterprises, ToxboxAI adapts to your unique operational needs.
      </p>
    </div>

    {/* Capabilities Grid */}
    <div className={styles.capabilitiesGrid26}>
      {/* Card 1 */}
      <div className={styles.capabilityCard26}>
        <div className={styles.cardIconContainer26}>
          <div className={styles.cardIcon26}>
            <img 
              src={iconT54}
              alt="Overwhelmed Support Icon" 
              className={styles.iconImage26}
            />
          </div>
        </div>
        <h3 className={styles.cardTitle26}>Mobile Network Operators</h3>
        
        <p className={styles.cardDescription26}>
          ✔️SIM activation & eSIM provisioning.<br /><br />
          ✔️Roaming support & international queries<br /><br />
          ✔️Data usage alerts & plan optimization<br /><br />
          ✔️Device compatibility checks
        </p>
      </div>

      {/* Card 2 */}
      <div className={styles.capabilityCard26}>
        <div className={styles.cardIconContainer26}>
          <div className={styles.cardIcon26}>
            <img 
              src={iconT56} 
              alt="Peak Hour Bottlenecks Icon" 
              className={styles.iconImage26}
            />
          </div>
        </div>
        <h3 className={styles.cardTitle26}>Broadband & Cable</h3>
        <p className={styles.cardDescription26}>
          ✔️Installation scheduling & tracking<br /><br />
          ✔️Speed test diagnostics & optimization<br /><br />
          ✔️Equipment troubleshooting & replacement<br /><br />
          ✔️Package upgrades & bundling.
        </p>
      </div>

      {/* Card 3 */}
      <div className={styles.capabilityCard26}>
        <div className={styles.cardIconContainer26}>
          <div className={styles.cardIcon26}>
            <img 
              src={iconT57} 
              alt="Rising Customer Expectations Icon" 
              className={styles.iconImage26}
            />
          </div>
        </div>
        <h3 className={styles.cardTitle26}>Enterprise Communications</h3>
        <p className={styles.cardDescription26}>
          ✔️Multi-location account management<br /><br />
          ✔️SLA monitoring & reporting<br /><br />
          ✔️Priority escalation workflows<br /><br />
          ✔️Custom integration & APIs
        </p>
      </div>
    </div>
  </div>
</section>




      <section className={styles.ctaSection74}>
  <div className={styles.sectionContent74}>
    <h2 className={styles.ctaHeadline74}>
      Ready to Transform Your Telecom Support?
    </h2>

    <p className={styles.ctaSubtext74}>
      Join forward-thinking telecom providers who are delivering exceptional customer experiences with ToxboxAI. Start your free trial today—no credit card required.
    </p>

    <div className={styles.ctaButtons74}>
      <button 
        className={`${styles.ctaButton74} ${styles.ctaPrimary74}`}
        onClick={() => handleCTAClick('Request a Demo')}
      >
        Start Free Trial →
      </button>

      <button 
        className={`${styles.ctaButton74} ${styles.ctaSecondary74}`}
        onClick={() => handleCTAClick('Get Started Now')}
      >
        Talk to Sales
      </button>
    </div>
  </div>
</section>

    </div>
  );
};

export default Telecom;
